import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { url } from '@datacamp/exercise-library-utils';
import config from '../config';
import { MULTIPLE_CHOICE_EXERCISE_TYPE, NORMAL_EXERCISE_TYPE } from '../interfaces/IExercise';
import mainAppClient from './mainApiClient';
const TRANSIENT_ERROR_STATUS_CODES = [408, 413, 429, 502, 503, 504, 521, 522, 524];
class SpreadsheetsApiClient {
  constructor(environment) {
    _defineProperty(this, "environment", void 0);
    this.environment = environment;
  }
  get endpoint() {
    return config(this.environment).urls.SPREADSHEETS_API;
  }
  async getExercise(exerciseId) {
    const resp = await fetch(url(this.endpoint, 'exercises', String(exerciseId)), {
      credentials: 'include'
    });
    const {
      exercise
    } = await resp.json();
    const exerciseType = exercise.type;
    switch (exerciseType) {
      case NORMAL_EXERCISE_TYPE:
        return {
          assignment: exercise.assignment,
          externalId: exercise.external_id,
          hint: exercise.hint,
          id: exercise.id,
          instructions: exercise.instructions,
          isRatingPermitted: exercise.isRatingPermitted,
          title: exercise.title,
          type: exerciseType,
          workbookId: exercise.workbook_id,
          xp: exercise.xp
        };
      case MULTIPLE_CHOICE_EXERCISE_TYPE:
        return {
          assignment: exercise.assignment,
          externalId: exercise.external_id,
          hint: exercise.hint,
          id: exercise.id,
          instructions: exercise.instructions,
          isRatingPermitted: exercise.isRatingPermitted,
          possibleAnswers: exercise.possibleAnswers,
          title: exercise.title,
          type: exerciseType,
          workbookId: exercise.workbook_id,
          xp: exercise.xp
        };
      default:
        throw new Error('Unrecognized exercise type.');
    }
  }
  async checkExercise(exerciseId) {
    const resp = await fetch(url(this.endpoint, 'exercises', String(exerciseId), 'check'), {
      body: JSON.stringify({
        sendProgressToMainApp: false
      }),
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST'
    });
    return resp.json();
  }
  async getWorkbook(workbookId) {
    const resp = await fetch(url(this.endpoint, 'workbooks', String(workbookId), 'workbook_copy'), {
      credentials: 'include'
    });
    const {
      workbook_copy: userWorkbook
    } = await resp.json();
    return {
      itemId: userWorkbook.google_item_id,
      url: userWorkbook.google_web_url,
      userWorkbookId: userWorkbook.id,
      workbookId
    };
  }
  async resetWorkbook(workbookId) {
    await fetch(url(this.endpoint, 'workbooks', String(workbookId)), {
      credentials: 'include',
      method: 'DELETE'
    });
  }
  async takeSolution(exerciseId) {
    await fetch(url(this.endpoint, 'exercises', String(exerciseId), 'take-solution'), {
      credentials: 'include',
      method: 'POST'
    });
  }
  async setSampleData(exerciseId) {
    const response = await fetch(url(this.endpoint, 'exercises', String(exerciseId), 'set_sample_data'), {
      credentials: 'include',
      method: 'POST'
    });
    if (TRANSIENT_ERROR_STATUS_CODES.includes(response.status)) {
      throw new Error("Failed to set sample data: ".concat(response.status, " ").concat(response.statusText));
    }
  }
  async getHint(exerciseId) {
    await fetch(url(this.endpoint, 'exercises', String(exerciseId), 'hint'), {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'GET'
    });
  }
  async authenticate() {
    const jwtToken = await mainAppClient(this.environment).getJwtToken();
    await fetch(url(this.endpoint, 'users', 'login'), {
      credentials: 'include',
      headers: {
        Authorization: "Bearer ".concat(jwtToken)
      },
      method: 'POST'
    });
  }
}
export default environment => new SpreadsheetsApiClient(environment);